import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/index.vue";

Vue.use(VueRouter);

// 保存原有的 push 方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

// 保存原有的 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err; // 其他错误抛出
    }
  });
};

const routes = [
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/",
        component: () => import("@/views/home/index.vue"),
        name: "home"
      },
      {
        path: "/purchase",
        component: () => import("@/views/projectInfo/index.vue"),
        name: "purchaseList",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/projectInfo/list.vue"),
            name: "projectList"
          },
          {
            path: "detail/:code",
            component: () => import("@/views/projectInfo/detail.vue"),
            name: "projectDetail"
          }
        ]
      },
      {
        path: "/info",
        component: () => import("@/layout/SideNavLayout.vue"),
        name: "info",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/info/list.vue"),
            name: "infoList"
          },
          {
            path: "detail/:code",
            component: () => import("@/views/info/detail.vue"),
            name: "infoDetail"
          },
          {
            path: ":code",
            component: () => import("@/views/info/_code.vue"),
            name: "CodeDetail"
          }
        ]
      },
      {
        path: "/shop",
        component: () => import("@/views/shop/index.vue"),
        name: "shop",
        children: [
          {
            path: "list/:code",
            component: () => import("@/views/shop/list.vue"),
            name: "shopList",
            meta: {
              hideBreadcrumb: true
            }
          },
          {
            path: "detail/:code/:id",
            component: () => import("@/views/shop/detail.vue"),
            name: "shopDetail",
            meta: {
              hideBreadcrumb: true,
              hideNav: true
            }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes
});

export default router;
